import axios from 'axios';

export function parseApiError(error: unknown, fallback = 'Erro na requisição'): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      | { error?: { message?: string }; message?: string; detail?: string | Array<{ msg?: string }> }
      | undefined;
    if (data?.error?.message) return data.error.message;
    if (typeof data?.message === 'string') return data.message;
    if (typeof data?.detail === 'string') return data.detail;
    if (Array.isArray(data?.detail)) {
      return data.detail.map((item) => item.msg || JSON.stringify(item)).join(', ');
    }
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
